// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1VydS","buttons":"SendReceipts_buttons__1Q2Ba","email":"SendReceipts_email__2tp3N","bookApptTitle":"SendReceipts_bookApptTitle__2OqaJ"};